import styled, { css } from 'styled-components';

import { Card, spaceMixin, token } from '@zillow/constellation';

export const StyledCard = styled(Card)`
  border-radius: 4px;
  margin: ${spaceMixin('xs')} 0;
  padding: ${spaceMixin('sm')} ${spaceMixin('sm')} ${spaceMixin('md')} ${spaceMixin('sm')};

  /* override */
  box-shadow: none;

  cursor: default;

  ${(props) =>
    props.isDisabled === false &&
    css`
      cursor: pointer;

      &:hover {
        /* color not in constellation */
        background-color: #f0faff;
      }

      &:active {
        /* set top, bottom margin = origin margin - border size */
        margin: 6px 0;
        background-color: ${token('colors.blue100')};
        border: 2px solid ${token('colors.gray300')};
      }
    `}
`;
